import Modernizr from 'modernizr';

import 'formvalidation/src/js/base';
import 'formvalidation/src/js/helper';
import 'formvalidation/src/js/framework/bootstrap';
import 'formvalidation/src/js/validator/notEmpty';

export default class ValidateMiscMessageForm {
  constructor(elem) {
    this.form = elem;
    // console.log(this.form);

    this.framework = 'bootstrap';
    this.trigger = 'blur';
    this.breakpoint = this._getBreakpoint();
    this.fields = this._getFieldsToValidate();
    this.icons = this._getIcons();
    console.log(this.fields);

    this.init();
  }

  init() {
    if (this.breakpoint === 'screen-sm') {
      this._validateForm(this._getValidationObject());
    } else {
      this._validateFormWithTooltip(
        this._getValidationObject({
          err: {
            container: 'tooltip'
          }
        })
      );
    }
  }

  _validateForm(obj) {
    $(this.form)
      .formValidation(obj)
      .on('success.form.fv', e => {
        // Prevent form submission
        e.preventDefault();
        this._processForm(e);
      });
  }

  _validateFormWithTooltip(obj) {
    $(this.form)
      .formValidation(obj)
      .on('err.field.fv', (e, data) => {
        const $input = data.element[0];
        const placement = $input.getAttribute('data-fv-tooltip-placement');
        const $icon = data.element.data('fv.icon');
        const title = $icon.data('bs.tooltip').getTitle();

        $icon.tooltip('destroy');

        data.element.tooltip({
          html: true,

          placement,

          template:
            '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',

          title,

          container: 'body'
        });
      })
      .on('success.field.fv', (e, data) => {
        data.element.tooltip('destroy');
      })
      .on('success.form.fv', e => {
        // Prevent form submission
        e.preventDefault();

        this._processForm(e);
      });
  }

  /* eslint-disable class-methods-use-this */
  _processForm(e) {
    const $form = $(e.target);
    const formData = new FormData();
    const params = $form.serializeArray();
    const $alert = $('#message-box');
    // const $alertSuccessTitle = $alert.attr('');
    // const $alertDangerTitle = $alert.attr('');
    $.each(params, (i, val) => {
      formData.append(val.name, val.value);
      if (val.name === 'recipient_id') {
        this.recipient_id = val.value;
      }
    });
    const request = $.ajax({
      beforeSend: () => {
        $('#js-loader').show();
      },
      cache: false,
      contentType: false,
      processData: false,
      url: $form.attr('action'),
      type: 'POST',
      data: formData
    });
    // console.log(request);
    request.done(response => {
      console.log(response);
    });

    request.fail((jqXHR, textStatus) => {
      // Show error message
      $alert.show(textStatus);
    });

    request.always(() => {
      $('#js-loader').hide();
    });
  }

  _getIcons() {
    const icons = {
      valid: 'fa fa-check',

      invalid: 'fa fa-times',

      validating: 'fa fa-refresh'
    };

    return icons;
  }

  _getBreakpoint() {
    let breakpoint;

    if (Modernizr.mq('(min-width: 992px)')) {
      breakpoint = 'screen-lg';
    } else if (Modernizr.mq('(min-width: 768px)')) {
      breakpoint = 'screen-md';
    } else {
      breakpoint = 'screen-sm';
    }

    return breakpoint;
  }
  /* eslint-enable class-methods-use-this */

  _getFieldsToValidate() {
    const fields = {
      message: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.form)
              .find('[name="misc"]')
              .attr('data-fv-notempty-message')
          }
        }
      }
    };

    return fields;
  }

  _getValidationObject({
    framework = this.framework,
    icon = this.icons,
    fields = this.fields,
    trigger = this.trigger,
    err
  } = {}) {
    const object = {
      framework,
      icon,
      fields,
      trigger,
      err
    };

    return object;
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/validate_misc_message_form.js